/// <reference path="../../../../Modules/Attr/Grid/NoboxEntityGrid.ts" />
namespace Nobox.Chat {

    @Serenity.Decorators.registerClass()
    export class ChatContactLinkGrid extends NoboxEntityGrid<ChatlinkcontactsRow, any> {
        //protected getDialogType() { return Nobox.Administration.UserDialog; }
        protected getColumnsKey() { return LeadLinkColumns.columnsKey; }
        protected getDialogType() { return ChatlinkcontactsDialog; }
        protected getIdProperty() { return ChatlinkcontactsRow.idProperty; }
        protected getInsertPermission() { return ChatlinkcontactsRow.insertPermission; }
        protected getLocalTextPrefix() { return ChatlinkcontactsRow.localTextPrefix; }
        protected getService() { return ChatlinkcontactsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected initEntityDialog(itemType, dialog) {
            super.initEntityDialog(itemType, dialog);
            Serenity.SubDialogHelper.cascade(dialog, this.element.closest('.ui-dialog'));
        }

        //protected addButtonClick() {
        //    this.editItem({ CtId: this.contactId });
        //}
        protected getColumns() {
            var columns = super.getColumns();

            columns.unshift({
                field: 'Unbind Link',
                name: '',
                format: ctx => '<a class="inline-action unbind-link" title="Unbind this link">' +
                    '<i class="fa fa-close text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });
            let listChannel = Q.getLookup("Nobox.ChannelAutomationLookup").itemById as unknown as Master.ChannelRow[];

            Q.first(columns, x => x.field == ChatlinkcontactsRow.Fields.ChId).format =
                ctx => `<a href="javascript:;" class="channel-link" data-id="${ctx.item.ChId}">${Q.htmlEncode(listChannel[ctx.value] == undefined ? "" : listChannel[ctx.value].Nm)}</a>`;

            return columns;
        }


        protected getPersistanceStorage(): Serenity.SettingStorage {
            return window.localStorage;
        }

        protected getButtons() {
            var buttons = super.getButtons();
            var $this = this;
            buttons[0].onClick = function () {
                var dlg = new ChatlinkcontactsDialog();
                dlg.linkgrid = $this;
                //dlg.
                dlg.loadEntityAndOpenDialog({ CtId: $this.contactId, ChId: $this.chId });
            };
            return buttons;
        }

        protected getInitialTitle() {
            return null;
        }

        protected getGridCanLoad() {
            return super.getGridCanLoad() && !!this.contactId;
        }

        private _ChId: number;

        private _ContactId: number;
        get contactId() {
            return this._ContactId;
        }
        set contactId(value: number) {
            if (this._ContactId !== value) {
                this._ContactId = value;
                this.refresh();
            }
        }
        get chId() {
            return this._ChId;
        }
        protected onViewSubmit(): boolean {
            if (!super.onViewSubmit()) { return false; }
            if (this._ContactId == null) { return false; }
            let request = this.view.params as Serenity.ListRequest;
            request.ColumnSelection = 1;
            var equalFilter = request.EqualityFilter as ChatlinkcontactsRow;
            equalFilter.CtId = this.contactId;
            request.EqualityFilter = equalFilter; return true;
        }
        set chId(value: number) {
            if (this._ChId !== value) {
                this._ChId = value;
                this.refresh();
            }
        }



        protected getQuickFilters() {
            var flt = super.getQuickFilters();

            var filter1 = Q.first(flt, x => x.field == ChatlinkcontactsRow.Fields.In);
            filter1.handler = h => {
                const request = (h.request as Serenity.ListRequest);
                const start = (h.widget as CustomDateFilter).get_value();
                const end = (h.widget as CustomDateFilter).end_get_value();
                if (h.active) {
                    if (start != null && end != null) {
                        request.Criteria = [[["In"], ">=", start], "and", [["In"], "<=", end]]
                    } else if (start != null) {
                        request.Criteria = [["In"], ">=", start];
                    } else if (end != null) {
                        request.Criteria = [["In"], "<=", end];
                    }
                    h.handled = true;
                } else {
                    request.Criteria = null;
                    h.handled = true;
                }
            };
            return flt;
        }
        
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);

            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault(); if (target.hasClass('unbind-link')) {
                    Q.confirm("Unbind this link ?", () => {
                        ChatlinkcontactsService.Update({
                            EntityId: item.Id,
                            Entity: {
                                CtId: null
                            }
                        }, res => {
                            this.refresh();
                        })
                    });
                }
            } else if (target.hasClass("channel-link")) {
                e.preventDefault();

                Q.notifySuccess("Success filter by channel");
                this.findQuickFilter(Serenity.ServiceLookupEditor,
                    ChatlinkcontactsRow.Fields.ChId).set_value(target.attr("data-id"));
                this.refresh();
            }
        }
    }
}